import React from "react";
import { Link } from "react-router-dom";
import "../../common/bg.css";
import "./c.css";
import WebsiteName from "../../common/WebsiteName/WebsiteName";
import Navbar from "../../common/Navbar/NavBar";
import Location from "../../common/Location/Location";
import Footer from "../../common/Footer/Footer";
export default function C_info() {
  return (
    <>
      <section className="bgImageCommon">
        <WebsiteName />
        <Navbar />
        <Location title="Mastering DataBase" />
        <section>
          <div className="cBody">
            <div id="cardDIV">
              <h1 className="text-dark" id="laguage_Title">
                Mastering DataBase
              </h1>
              <p className="text-secondary" id="Language_Para">
                Computer databases typically store aggregations of data records
                or files that contain information, such as sales transactions,
                customer data, financials and product information. Databases are
                used for storing, maintaining and accessing any sort of data.
                They collect information on people, places or things.
                <br />
                The data is stored in a neater way and hence, more data can be
                stored. A DBMS is a highly secure platform so confidential and
                high-risk data can also be stored and accessed, securely. DBMS
                makes handling of data very simple.
                <br />
                A collection of data, commonly called a database, contains
                information about a particular enterprise. It maintains any
                information that may necessary to the decision-making process
                involved in the management of that organization.,
                <br />
                Database is Self Describing in Nature, Insulation between
                Program and Data, Supports Multiple Views of Data, Sharing
                Knowledge, and Multi-User Transactions in the Database.
              </p>
              <Link
                name=""
                id=""
                class="btn btn-danger"
                to="/Courses"
                role="button">
                {"<< "}back
              </Link>
            </div>
          </div>
        </section>
        <Footer />
      </section>
    </>
  );
}
